/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Stock
 */
export interface Stock {
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof Stock
     */
    stockLevel: string;
}

/**
 * Check if a given object implements the Stock interface.
 */
export function instanceOfStock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productName" in value;
    isInstance = isInstance && "stockLevel" in value;

    return isInstance;
}

export function StockFromJSON(json: any): Stock {
    return StockFromJSONTyped(json, false);
}

export function StockFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'productName': json['productName'],
        'stockLevel': json['stockLevel'],
    };
}

export function StockToJSON(value?: Stock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'productName': value.productName,
        'stockLevel': value.stockLevel,
    };
}

